import React from 'react';
import { SidebarActions } from './RightActions';

const SidebarActionsWrapper: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
  return <SidebarActions collapsed={collapsed} />;
};

export default SidebarActionsWrapper;
